/**
 * Created by tofael on 7/12/17.
 */
import {typography} from 'material-ui/styles';
import {grey600} from 'material-ui/styles/colors';

const styles = {
  navigation: {
    fontSize: 15,
    fontWeight: typography.fontWeightLight,
    color: grey600,
    paddingBottom: 15,
    display: 'block'
  },
  header: {
    fontWeight: '700',
    color: '#666',
    margin: '0',
    padding: '15px',
    fontSize: '24px',
    opacity: '.9',
    textTransform: 'capitalize',
    display:'inline-block'
  },
  subheader: {
    fontSize: '16px',
    color: '#666',
    borderBottom: '1px solid rgba(0,0,0,.12)',
    position: 'relative',
    fontWeight: '400',
    textTransform: 'uppercase',
    backgroundColor: '#f4f4f4'
  },
  panel: {
    backgroundColor: '#fff',
    transition: 'none',
    border: 'none',
    borderRadius: '5px',
    position: 'relative',
    marginBottom: '24px',
    boxShadow: '0 5px 5px 0 rgba(0,0,0,.25)'
  },
  title: {
    fontSize: 24,
    fontWeight: typography.fontWeightLight,
    marginBottom: 20
  },
  paper: {
    padding: 30
  },
  clear: {
    clear: 'both'
  },
  callColor: {
    waiting: 'red',
    calling: 'green',
    sleeping: 'blue'
  },
  status: {
    fontSize: 17.2
  },
  noData: {
    textAlign :'center',
    fontSize:16,
    marginTop:'15%',
    fontWeight: typography.fontWeightLight
  },
  table: {
    body: {
      padding: '15px',
      height: 80,
      fontSize: 18,
      fontWeight: typography.fontWeightLight,
      color: '#666'
    },
    header: {
      fontSize: 16,
      color: '#060606'
    },
    cell: {
      padding: '10px'
    },
  },
  statusColor: {
    red: '#D02504',
    green: '#D02504',
    done: '#4A90E2',
    waiting: '#EFB71E',
    notified: '#595959',
    dispatched: '#14A46E',
    arrived: '#285F03',
    investigating: '#23C2D7',
    finished: '#3562a0',
    'start-visit': '#14A46E',
    'patient-canceled': '#FF7E02',
    'doctor-canceled': '#F5236A',
    'follow-up': '#6300A5',
    'on follow-up': '#1439A4'
  },
  paymentStatusColor: {
      billed: '#EFB71E',
      paid: '#14A46E'
  },
  stateColor: {
    waiting: '#0486D0',
    done: '#202066',
    calling: '#D00461',
    sleeping: '#2d1d66'
  },
  ringer: {
    accept: {
      width: '29px',
      height: '29px',
      background: 'url(./public/images/icons/dialer/caller-sprite.png) no-repeat scroll -31px 0',
      display: 'inline-block',
      float: 'right',
      cursor: 'pointer',
      margin: '0px 5px'
    },
    reject: {
      width: '38px',
      height: '29px',
      background: 'url(./public/images/icons/dialer/caller-sprite.png) no-repeat scroll -61px 0',
      display: 'inline-block',
      float: 'left',
      cursor: 'pointer',
      margin: '0px 5px'
    },
    hold: {
      width: '38px',
      height: '29px',
      background: 'url(./public/images/icons/dialer/caller-sprite.png) no-repeat scroll -98px 0',
      display: 'inline-block',
      float: 'left',
      cursor: 'pointer',
      margin: '0px 5px'
    },
    container: {
      position: 'fixed',
      zIndex: 99999,
      width: '300px',
      top: '0px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'rgb(91, 91, 91)',
      padding: '10px'
    },
    callerInfo: {
      display: 'inline-block',
      verticalAlign: '-webkit-baseline-middle',
      width: '195px',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      color: '#FFF',
      float: 'left',
      textAlign: 'center',
      lineHeight: '30px'
    }
  }
};

export default styles;


// WEBPACK FOOTER //
// ./src/utility/styles.js